import type { ReactNode } from 'react';

export const symbol_time_auto: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M413-355h132l16 50q3 9 11 14.5t18 5.5q16 0 24.5-13t3.5-28l-94-265q-4-10-12.5-16t-19.5-6h-24q-11 0-19.5 6T436-590l-95 266q-5 14 3.5 26.5T368-285q10 0 18-6t11-15l16-49Zm16-48 51-153 50 153H429Zm-39-457q-13 0-21.5-8.5T360-890q0-13 8.5-21.5T390-920h180q13 0 21.5 8.5T600-890q0 13-8.5 21.5T570-860H390Zm-49.5 750.5Q275-138 226-187t-77.5-114.5Q120-367 120-441t28.5-139.5Q177-646 226-695t114.5-77.5Q406-801 480-801q67 0 126 22.5T711-716l30-30q9-9 21-9t21 9q9 9 9 21t-9 21l-30 30q36 40 61.5 97T840-441q0 74-28.5 139.5T734-187q-49 49-114.5 77.5T480-81q-74 0-139.5-28.5Zm352-119Q780-316 780-441t-87.5-212.5Q605-741 480-741t-212.5 87.5Q180-566 180-441t87.5 212.5Q355-141 480-141t212.5-87.5ZM480-440Z"
		/>
	</svg>
);
